import I18n from '@/modules/i18n';
import Templates from '@/pages/site/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  static targets = ['url'];

  gridyOptions() {
    return {
      headers: [
        { name: I18n.t('created_at.male'), value: 'created_at' },
        { name: I18n.t('activerecord.attributes.withdraw.paying_at'), value: 'paying_at' },
        { name: I18n.t('activerecord.attributes.withdraw.total_cents'), value: 'total_cents' },
        { name: I18n.t('activerecord.attributes.withdraw.tax_cents'), value: 'tax_cents' },
        { name: I18n.t('activerecord.attributes.withdraw.amount_cents'), value: 'amount_cents' },
        { name: I18n.t('activerecord.attributes.withdraw.bank_agency'), value: 'bank_agency' },
        { name: I18n.t('activerecord.attributes.withdraw.bank_number'), value: 'bank_number' },
        { name: I18n.t('activerecord.attributes.withdraw.bank_kind'), value: 'bank_kind' },
      ],

      idSortName: 'id',
      idSortOrder: 'desc',
      sortName: 'paying_at',
      sortOrder: 'desc',
      template: Templates.withdraws.gridy,
      url: this.urlTarget.value,
    };
  }
}
